var EliteSummonEvent = {}
// --召唤信息
EliteSummonEvent.EliteSummon_Message = "EliteSummonEvent.EliteSummon_Message"

// --预言召唤
EliteSummonEvent.PresageSummon_Message = "EliteSummonEvent.PresageSummon_Message"
// --刷新
EliteSummonEvent.PresageSummon_ReFresh = "EliteSummonEvent.PresageSummon_ReFresh"
// --购买返回
EliteSummonEvent.PresageSummon_Buy_Return = "EliteSummonEvent.PresageSummon_Buy_Return"
// --打开松果
EliteSummonEvent.PresageSummon_Open_Pine = "EliteSummonEvent.PresageSummon_Open_Pine"

module.exports = EliteSummonEvent
